import styled from "@emotion/styled";
import { injectGlobal } from "@emotion/css";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import { Form, Radio, Checkbox, Select } from "antd";

export const FieldContainer = styled(Form.Item)`
  width: 100%;
  margin: 0;

  .ant-form-item-label {
    padding: 0;
    margin-bottom: ${(props) =>
      props.marginBottom !== undefined ? props.marginBottom : "24px"};
  }
  .ant-form-item-label > label::after {
    content: "";
  }

  label {
    font-family: "Noto Sans Thai", "Noto Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;

    color: #4b5768;
  }

  ${(props) =>
    responsive.mobile(css`
      .ant-form-item-label {
        margin-bottom: ${props.marginBottom !== undefined
          ? props.marginBottom
          : "16px"};
      }
    `)}
`;

export const SubFieldContainer = styled.div`
  width: calc(100% - 22px);
  margin-left: 22px;
`;

export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
`;

export const RadioItem = styled(Radio)`
  font-weight: 700 !important;
  margin-bottom: 24px;

  --antd-wave-shadow-color: #058459;

  .ant-radio-checked .ant-radio-inner {
    border-color: #058459 !important ;
    background-color: #b5f6df;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: #058459;
  }

  .ant-radio-checked .ant-radio-inner:focus {
    border-color: #058459;
  }

  .ant-radio-checked::after {
    border-color: #058459;
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: #058459;
  }

  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: 0 0 0 0px #fff;
  }

  ${responsive.mobile(css`
    margin-bottom: 16px;
  `)}
`;

export const CheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: ${(props) => (props.direction === "row" ? "row" : "column")};
  justify-content: center;

  label {
    margin: 0;
  }
`;

export const CheckboxItem = styled(Checkbox)`
  font-weight: 700 !important;
  margin-bottom: 24px;

  --antd-wave-shadow-color: #058459;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #058459 !important;
    border-color: #058459 !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #058459 !important;
  }

  ${responsive.mobile(css`
    margin-bottom: 16px;
  `)}
`;

export const CustomSelect = styled(Select)`
  width: ${(props) => (props.width ? props.width : "368px")} !important;
  max-width: 100%;
  height: 52px;

  .ant-select-selector {
    height: 100% !important;
  }

  input {
    height: 100% !important;
  }

  .ant-select-selection-item {
    line-height: 50px !important;

    font-family: "Noto Sans Thai", "Noto Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
  }

  .ant-select-selection-placeholder {
    line-height: 50px !important;

    font-family: "Noto Sans Thai", "Noto Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;

    color: #b8c0cc;
  }

  .ant-select-arrow {
    width: 12px;
  }

  &:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #058459;
  }
  .ant-select-focused:not(.ant-select-disabled)&:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: #058459;
    box-shadow: 0 0 0 2px rgba(2, 52, 35, 0.2);
    border-right-width: 1px !important;
    outline: 0;
  }

  &.ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    color: #4b5768 !important;
  }

  margin-bottom: ${(props) =>
    props.marginBottom !== undefined ? props.marginBottom : "24px"};

  ${(props) =>
    responsive.mobile(css`
      margin-bottom: 16px;
      width: ${props.widthRs ? props.widthRs : "343px"} !important;
    `)}
`;

export const Option = styled(Select.Option)``;

export const Label = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  color: #4b5768;

  white-space: pre-line;
`;

export const Note = styled(Label)`
  font-weight: 700;
`;

export const Highlight = styled(Label)`
  font-weight: 700;
  color: #fc6b4b;
  text-decoration: underline;
`;

export const SubmitButton = styled.button`
  border-radius: 100px;
  padding: 14px 32px;
  width: 206px;
  height: 51px;
  color: #ffffff;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;
  border: none;
  background: ${(props) => (props.disabled ? "#d0d5dd" : "#16AF7B")};
  color: ${(props) => (props.disabled ? "#64748b" : "white")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

export const DateField = styled(FieldContainer)`
  input {
    border-radius: 4px;
    height: 52px;
    font-size: 18px;
  }
  .ant-picker {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }
  .ant-picker-input {
    padding-bottom: 0 !important;
  }
`;

injectGlobal`
  --antd-wave-shadow-color: #058459;

  .ant-select-item {
    padding: 15px 24px !important;
  }

  .ant-select-item-option-content {
    font-family: 'Noto Sans Thai', 'Noto Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;

    color: #4B5768;
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: #f5f5f5;
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: #B5F6DF !important;
    .ant-select-item-option-content {
      color: #058459 !important;
      font-weight: 700 !important;
    }
  }
`;
